import FromAboutUs from './FromAboutUs'
import { useEffect, useState } from 'react'
import { get } from 'lodash'
import Cookies from 'js-cookie'

import { USER_TOKEN_KEY } from '../../modules/auth/core/_cookie'
import { callapiFile } from '../../modules/auth/core/_requestContent'
import { apiGetPageBySlug, apiCreateOrUpdatePage } from '../../modules/auth/core/_requestPage'

const AboutUsWrapper = () => {
  const [content, setContent] = useState([])

  const enableSplashScreen = () => {
    const splashScreen = document.getElementById('splash-screen')
    if (splashScreen) splashScreen.style.setProperty('display', 'flex')
  }

  const disableSplashScreen = () => {
    const splashScreen = document.getElementById('splash-screen')
    if (splashScreen) splashScreen.style.setProperty('display', 'none')
  }

  const getAboutUs = () => {
    enableSplashScreen()
    apiGetPageBySlug('about')
      .then((res) => setContent(JSON.parse(get(res, 'data.data.data', ""))))
      .catch((error) => {
        if (String(error?.response?.data?.message || "").includes("Token")) {
          enableSplashScreen()
          Cookies.remove(USER_TOKEN_KEY)
          setTimeout(() => {
            window.location.reload()
          }, 500)
        }
      })
      .finally(() => setTimeout(() => { disableSplashScreen() }, 200))
  }

  const setTermAndConditions = async (value) => {
    enableSplashScreen()
    // check image
    if (typeof value.file === 'object' && value.file !== null) {
      const image = await new Promise((resolve, reject) => {
        callapiFile(value.file)
          .then((res) => resolve({ logo_image: get(res, 'data.data.filePath', '') }))
          .catch(reject)
      })

      if (image?.logo_image !== "")
        value = Object.assign({}, value, { logo_image: image?.logo_image })
    }
    apiCreateOrUpdatePage('about', value)
      .then(console.log)
      .catch(console.error)
      .finally(() => getAboutUs())
  }

  useEffect(() => {
    getAboutUs()
    // eslint-disable-next-line
  }, [])

  return <div className="container" style={{ minHeight: '90vh' }}>
    {content?.title && <FromAboutUs
      title={content.title || ""}
      logo_image={content?.logo_image || ""}
      content_detail={content?.content_detail || ""}
      onSubmit={setTermAndConditions} />}
  </div>
}

export { AboutUsWrapper }